/**
 * Mongo query to check if a field not exists or is null
 * @param field Fieldname
 * @returns Mongo query
 */
export function mongoNotExistsOrNull(field: string) {
  return { $or: [{ [field]: { $exists: false } }, { [field]: null }] };
}

/**
 * Mongo query to check if a field exists and is not null
 * @param field Fieldname
 * @returns Mongo query
 */
export function mongoExistsAndNotNull(field: string) {
  return { [field]: { $ne: null } };
}

/**
 * Mongo query to check if a field not exists or is null or is an empty string
 * @param field Fieldname
 * @returns Mongo query
 */
export function mongoNotExistsOrNullOrEmptyString(field: string) {
  return { $or: [{ [field]: { $exists: false } }, { [field]: null }, { [field]: '' }] };
}
